import { render, staticRenderFns } from "./CourseThumb.vue?vue&type=template&id=34d19457&scoped=true"
import script from "./CourseThumb.vue?vue&type=script&lang=js"
export * from "./CourseThumb.vue?vue&type=script&lang=js"
import style0 from "./CourseThumb.vue?vue&type=style&index=0&id=34d19457&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d19457",
  null
  
)

export default component.exports